<template>
<div>
  <yilmer-nav></yilmer-nav>
  <main role="main">
    <!-- Main jumbotron for a primary marketing message or call to action -->
    <section-head></section-head>
    <yilmer-projects></yilmer-projects>
    <yilmer-events></yilmer-events>
    <yilmer-albums></yilmer-albums>
    <hr>
    <yilmer-news></yilmer-news>
    <yilmer-footer></yilmer-footer>
  </main>
  <footer class="container">
    
  </footer>
</div>

</template>

<script>
import YilmerNav from './YilmerNav';
import SectionHead from './SectionHead';
import YilmerEvents from './YilmerEvents';
import YilmerAlbums from './YilmerAlbums';
import YilmerProjects from './YilmerProjects';
import YilmerNews from './YilmerNews';
import YilmerFooter from './YilmerFooter';

export default {
  name: 'HelloWorld',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
    YilmerNav,
    SectionHead,
    YilmerEvents,
    YilmerAlbums,
    YilmerProjects,
    YilmerNews,
    YilmerFooter
  }
}

</script>

<style scoped="">
body {
  padding-top: 7.25rem;

}
hr {
  border: solid 5px rgb(110, 186, 208);
  margin: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue